const activeNetwork = (state = 'ethereum', action) => {
  switch (action.type) {
    case 'SET_ACTIVE_NETWORK':
      return action.network
    default:
      return state
  }
}

export default activeNetwork;